var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderAzureOpenai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 264,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1257,
    y: 660,
    width: 291,
    height: 264
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 660,
    width: 289,
    height: 263
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 660,
    width: 289,
    height: 263
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 660,
    width: 289,
    height: 263
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 660,
    width: 289,
    height: 263
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 666,
    width: 283,
    height: 257
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1271,
    y: 666,
    width: 263,
    height: 257
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1271,
    y: 666,
    width: 263,
    height: 257
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1271,
    y: 666,
    width: 263,
    height: 257
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1257 -660)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3475.47 1567.5C3492.46 1568.3 3508.88 1575.75 3520.81 1588.94L3508.33 1600.36C3494.84 1585.45 3473.62 1580.42 3454.93 1587.68 3436.23 1594.96 3423.91 1613.04 3423.91 1633.19L3423.96 1633.19 3423.96 1691.75 3484.49 1729.34 3476.96 1741.59 3407.04 1698.16 3407.79 1696.93 3407.04 1696.93 3407.04 1633.19C3407.04 1606.02 3423.65 1581.66 3448.84 1571.86 3455.15 1569.41 3461.66 1568 3468.16 1567.57 3470.6 1567.41 3473.05 1567.39 3475.47 1567.5Z",
    fill: "#00B0F0",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00349 0 0 1 -2094.25 -900.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3593.68 1620.82C3601.6 1635.91 3603.48 1653.86 3598.18 1670.81L3582.05 1665.75C3588.05 1646.59 3581.65 1625.71 3565.94 1613.2 3550.24 1600.69 3528.46 1599.12 3511.13 1609.26L3511.16 1609.3 3460.8 1638.74 3459.06 1716.84 3444.73 1709.63 3446.74 1627.33 3448.17 1627.35 3447.79 1626.71 3502.6 1594.67C3525.97 1581 3555.32 1583.12 3576.48 1599.98 3581.76 1604.19 3586.27 1609.11 3589.93 1614.52 3591.3 1616.56 3592.56 1618.65 3593.68 1620.82Z",
    fill: "#00B0F0",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00349 0 0 1 -2094.25 -900.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3603.32 1749.54C3594.25 1763.97 3579.69 1774.63 3562.37 1778.56L3558.63 1762.08C3578.21 1757.63 3593.04 1741.61 3595.95 1721.74 3598.87 1701.87 3589.28 1682.26 3571.8 1672.37L3571.77 1672.42 3521 1643.69 3452.62 1681.46 3451.65 1665.45 3523.81 1625.79 3524.49 1627.05 3524.86 1626.39 3580.12 1657.66C3603.67 1670.99 3616.6 1697.42 3612.68 1724.19 3611.69 1730.89 3609.7 1737.26 3606.87 1743.14 3605.8 1745.35 3604.62 1747.49 3603.32 1749.54Z",
    fill: "#00B0F0",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00349 0 0 1 -2094.25 -900.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3497.89 1823.79C3480.9 1822.99 3464.48 1815.57 3452.55 1802.45L3465.02 1791.09C3478.52 1805.92 3499.73 1810.94 3518.43 1803.7 3537.13 1796.47 3549.45 1778.48 3549.45 1758.42L3549.4 1758.42 3549.4 1700.16 3482.96 1659.3 3496.39 1650.57 3566.32 1693.8 3565.57 1695 3566.32 1695 3566.32 1758.42C3566.32 1785.45 3549.71 1809.7 3524.52 1819.45 3518.21 1821.89 3511.7 1823.29 3505.2 1823.71 3502.76 1823.87 3500.31 1823.9 3497.89 1823.79Z",
    fill: "#00B0F0",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00349 0 0 1 -2094.25 -900.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3379.63 1769.93C3371.82 1754.78 3370.05 1736.82 3375.46 1719.91L3391.57 1725.06C3385.44 1744.19 3391.7 1765.1 3407.32 1777.72 3422.95 1790.33 3444.71 1792.04 3462.11 1782L3462.09 1781.96 3512.63 1752.84 3514.87 1674.75 3529.15 1682.05 3526.62 1764.34 3525.19 1764.3 3525.57 1764.95 3470.55 1796.66C3447.1 1810.16 3417.77 1807.87 3396.71 1790.87 3391.44 1786.62 3386.97 1781.67 3383.35 1776.24 3381.98 1774.2 3380.75 1772.09 3379.63 1769.93Z",
    fill: "#00B0F0",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00349 0 0 1 -2094.25 -900.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3369.87 1640.71C3379.16 1626.42 3393.87 1615.97 3411.24 1612.28L3414.74 1628.82C3395.1 1632.98 3380.04 1648.79 3376.85 1668.62 3373.65 1688.44 3382.96 1708.18 3400.29 1718.33L3400.32 1718.28 3450.68 1747.73 3519.58 1710.93 3520.33 1726.96 3447.62 1765.58 3446.94 1764.32 3446.57 1764.97 3391.76 1732.91C3368.4 1719.26 3355.84 1692.64 3360.15 1665.92 3361.23 1659.25 3363.32 1652.9 3366.24 1647.06 3367.33 1644.87 3368.55 1642.75 3369.87 1640.71Z",
    fill: "#00B0F0",
    fillRule: "evenodd",
    fillOpacity: 1,
    transform: "matrix(1.00349 0 0 1 -2094.25 -900.852)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderAzureOpenai);
export default __webpack_public_path__ + "static/media/provider-azure-openai.f64dee5037a3c3228f45e9ae8d06db43.svg";
export { ForwardRef as ReactComponent };